<template>
  <v-card class="card-alert">
    <v-card-text>
      <div class="alert-menu">
        <v-alert
          v-for="item in getListIsNotPago" :key="item"
          v-model="snackbar"
          color="#5C6BC0"
          class="alert-menu-sub"
          >
          <div>
            <div>
              <h2 class="span-alert">{{ item.nome }}</h2>
            </div>
            <div class="pt-2">
              <span class="span-alert"> Data de Vencimento: <strong>{{item.data_vencimento }} / </strong></span>
              <span class="span-alert">Descrição: {{ item.descricao }}</span>
            </div>
          </div>
          <div>
            <v-btn
              icon
              color="green"
              @click="openPagar(item)"
            >
              <v-icon color="white">mdi-check-circle</v-icon>
            </v-btn>
          </div>
        </v-alert>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  /* eslint-disable */
  props: {
    objValue: Object,
  },

  data () {
    return {
      objEdit:{},
      snackbar: true,
      dialogDelete:false,
    }
  },
  computed: {
    ...mapGetters('boleto',['getList']),
    getListIsNotPago(){
      return this.getList.filter((item)=>{
        return !item.isPago
      })
    }
  },
  async created () {
    await this.getAllBoletos ( )
  },
  methods: {
    ...mapActions('boleto', ['getAllBoletos']),
    ...mapActions('boleto', ['updateBoleto']),
    initialize () {
      this.boletos = ['']
    },
    async openPagar(item){
      const isPago = confirm('Este boleto foi pago?')
      if(isPago){
        await this.updateBoleto({
          ...item,
          isPago: true
        })
      }
      await this.getAllBoletos();
    }
  }
}
</script>

<style>
.card-alert {
  height: 100% !important;
}
.v-alert__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.span-alert {
  color: white;
}
.btn-span{
  margin-right: 5px;
}
</style>

